import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  getCartId,getAuthToken } from '../../utils/auth';

 
export const fetchCartItems = createAsyncThunk('cart/fetchCartItems', async () => {
    const cart_id = getCartId();
    // if (cart_id !== ''){
        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/'+cart_id+'/cart',{
            headers: {
                'Content-Type':'application/json',
            }, 
            method: 'GET'
        }); 
        return response.json();
   // } 
});
 
export const addToCart = createAsyncThunk('cart/AddToCart', async (cart:  {variant_id: string, qty:string, price:string, actualPrice:string, selectedSize?: string }) => {
    // const token = getAuthToken();
     const cart_id = getCartId();
     //console.log("carttttt",cart)
     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/add_to_cart',{
          headers: {
              'Content-Type':'application/json',
            }, 
            method: 'POST',
            body: JSON.stringify({variant_id: cart.variant_id, quantity: cart.qty,cart_id: cart_id,price:cart.price,actual_price: cart.actualPrice, size: cart.selectedSize}),
  
     }); 
      return response.json(); 
});

export const removeFromCart = createAsyncThunk('cart/removeFromCart', async (id: string) => {
     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/'+id+'/remove_from_cart',{
          headers: {
              'Content-Type':'application/json',
            }, 
            method: 'DELETE',
  
     }); 
      return response.json(); 
 });
  
 export const updateItems = createAsyncThunk('cart/updateItems', async (cartItems:  [{id: string, quantity:string }]) => {
     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/update_cart_items',{
          headers: {
              'Content-Type':'application/json',
            }, 
            method: 'POST',
            body: JSON.stringify({cartItems}),
  
     }); 
      return response.json(); 
});

export const placeOrder = createAsyncThunk('cart/placeOrder', async (data: {selectedAddress, cartTotal,newAddress: {},type:string}) => {
    const cart_id = getCartId(); 
    const token = getAuthToken();


    if (data.type === "withCustomer"){
        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/process_checkout', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,

            },
            body: JSON.stringify({ addressId: data.selectedAddress,amount: data.cartTotal,cart_id: cart_id,type: data.type }) // Amount in paise
          });
          return response.json(); 
    }
    if (data.type === "withOutCustomer"){
        const cart_id = getCartId(); 
        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/process_checkout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ address: data.newAddress,amount: data.cartTotal,cart_id: cart_id,type: data.type }) // Amount in paise
            });
            return response.json(); 
    }
   

});

// export const placeOrder = createAsyncThunk('cart/placeOrder', async (data: {newAddress: {},cartSubtotal}) => {
//     const cart_id = getCartId(); 
//     console.log("ssssssssssssssss",data.cartSubtotal, data.newAddress)
//     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/cart/process_checkout', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({ address: data.newAddress,amount: data.cartSubtotal,cart_id: cart_id }) // Amount in paise
//       });
//       return response.json(); 

// });
 
 
 
// Slice
const cartSlice = createSlice({
    name: 'cart',
    initialState: { 
        loading: false,
        formErrors: [],
        cartSubtotal: 0,
        cart: [],
        error: '',
        cart_id: '' ,
        modalShow: false,
        isOrderPlaced: false

    },
    reducers: {
        updateSubTotal: (state, action) => {
            //console.log("action",action.payload)
            state.cartSubtotal = action.payload
        },
        makeEmptyCart: ()=> {
            sessionStorage.setItem('cart_id',  '');
        },
        submitPlaceOrder: (state) => {
            state.isOrderPlaced = true;
        }
        // openModal: state => {
        //     state.modalShow = true;
        // },
        // closeModal: state => {
        //     state.modalShow = false;
        // }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addToCart.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(addToCart.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.cart = action.payload['data']; 
                    state.error = '';
                    sessionStorage.setItem('cart_id',  action.payload['data']['id']);
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            .addCase(addToCart.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
            })
            .addCase(removeFromCart.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(removeFromCart.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.cart['line_items'] = state.cart['line_items'].filter(item => item.id+'' !== action.payload.removed_id+'');
                    state.error = '';
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            .addCase(removeFromCart.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
            })
            
            .addCase(fetchCartItems.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(fetchCartItems.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.cart = action.payload['data']; 
                    state.error = '';
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            

            .addCase(updateItems.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(updateItems.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.cart = action.payload['data']; 
                    state.error = '';
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            .addCase(updateItems.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
            })

            .addCase(placeOrder.pending, (state) => {
                state.loading = true;
                state.error = '';
                state.isOrderPlaced = true;
            })
            .addCase(placeOrder.fulfilled, (state, action) => {
               // console.log("action payload of place order", action.payload)
                if (action.payload.status === "success"){
                    state.formErrors = []
                    state.isOrderPlaced = true;
                    state.loading = false;
                }
                else if (action.payload.status === "PAYMENT_INITIATED"){

                    if (action.payload.code === 200) {
                        state.isOrderPlaced = true;
                        state.loading = false;

                        //     console.log("aaaaaaaaaaaaaaaaaaaaaa",data)
                         window.location.href = action.payload.url;
                    } 
                    else {
                        state.isOrderPlaced = false;
                        state.loading = false;
                    }
                    
                }
                else{
                    state.isOrderPlaced = false;
                    state.formErrors = action.payload.errors
                    state.loading = false;
                }
                
            })
            .addCase(placeOrder.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
                state.isOrderPlaced = false;
            })
            
    }
});

export const { updateSubTotal,makeEmptyCart,submitPlaceOrder } = cartSlice.actions;
export default cartSlice.reducer;
